import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { CrossIcon } from '../../assets/icons/index';
import Button from '../button/index';
import { DeprecatedModalWrapper } from './modal-wrapper';

export type ModalProps = {
  children?: ReactNode;
  className?: string;
  crossButton?: boolean;
  description?: ReactNode;
  descriptionClassName?: string;
  dismissButtonClassName?: string;
  dismissButtonContent: ReactNode;
  isOpen: boolean;
  onDismiss?: () => void;
  onHardClose?: () => void;
  onSuccess?: () => void;
  successButtonClassName?: string;
  successButtonContent: ReactNode;
  successButtonDisabled?: boolean;
  title?: ReactNode;
  titleClassName?: string;
};

const Modal: FC<ModalProps> = ({
  onDismiss,
  onSuccess,
  children,
  dismissButtonContent,
  successButtonContent,
  successButtonDisabled,
  className,
  description,
  descriptionClassName,
  dismissButtonClassName,
  successButtonClassName,
  onHardClose,
  title,
  titleClassName,
  isOpen,
  crossButton,
}) => (
  <DeprecatedModalWrapper isOpen={isOpen}>
    <div
      className={twMerge(
        'relative flex w-full max-w-[450px] flex-col gap-8 rounded bg-white p-4',
        className,
      )}
    >
      {crossButton && (
        <Button
          className="absolute right-2 top-2 h-fit w-fit rounded-full bg-gray-50 p-2 transition-colors hover:bg-gray-200"
          onClick={() => onHardClose?.()}
          styleType="NONE"
        >
          <CrossIcon className="h-3 w-3" iconColor="#344054" />
        </Button>
      )}
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <span className={twMerge('text-xl font-[550] text-gray-700', titleClassName)}>
            {title}
          </span>
          <span className={twMerge('text-xs font-[450] text-gray-500', descriptionClassName)}>
            {description}
          </span>
        </div>
        {children}
      </div>
      <div className="flex h-11 justify-end gap-3">
        <Button
          className={twMerge(
            'border-[1px] border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700 transition-colors hover:bg-gray-50',
            dismissButtonClassName,
          )}
          onClick={() => onDismiss?.()}
          styleType="DEFAULT_ROUNDED"
        >
          {dismissButtonContent}
        </Button>
        <Button
          className={twMerge(
            'w-fit rounded bg-fireside-600 px-6 py-[10px] text-sm font-[550] text-white',
            successButtonClassName,
          )}
          disabled={successButtonDisabled}
          onClick={() => onSuccess?.()}
          styleType="NONE"
        >
          {successButtonContent}
        </Button>
      </div>
    </div>
  </DeprecatedModalWrapper>
);

Modal.displayName = 'Modal';

export default Modal;
